export const TOOLTIP_SHADOW_TEST_ID = 'Tooltip-Shadow';

export const INFOTIP_FLOAT_TEST_ID = 'Infotip-float';
export const INFOTIP_ANCHOR_TEST_ID = 'Infotip-anchor';
